// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowUp: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6">
            <path
                fill="currentColor"
                d="M8.25058579,5.2482419 C8.05867982,5.2482419 7.86667943,5.17499971 7.72042966,5.02851534 L4.50058579,1.80996072 L1.28027344,5.03027344 C0.987304688,5.32324219 0.512695312,5.32324219 0.219726562,5.03027344 C-0.0732421875,4.73730469 -0.0732421875,4.26269531 0.219726562,3.96972656 L3.96972656,0.219726562 C4.26269531,-0.0732421875 4.73730469,-0.0732421875 5.03027344,0.219726562 L8.78027344,3.96972656 C9.07324219,4.26269531 9.07324219,4.73730469 8.78027344,5.03027344 C8.63496065,5.17558551 8.44277358,5.2482419 8.25058579,5.2482419 Z"
                transform="translate(0 .502)"
            />
        </svg>
    );
};

export default React.memo(ArrowUp);
